<template>
    <div class="clearfix">
        <compFormEdit ref="dataForm" :labelWidth="150" v-model="formData" :formdata="getBase"></compFormEdit>
    </div>
</template>

<script>
export default {
    props: ['originData'],
    data () {
        return {
            loading: false,
            formData: {}
        }
    },
    computed: {
        getBase () {
            return [
                {
                    label: '预计到仓时间',
                    key: 'expect_stockin_at',
                    tag: 'vDatepicker',
                    props:{
                        format:'yyyy-mm-dd',
                        confirm:false,
                    },
                    style: {
                        'width': '220px'
                    },
                    required: true
                }
            ]
        },
    },
    methods: {
        async checkForm () {
            try {
                await this.$refs.dataForm.validate();
            }
            catch (e) {
                return false;
            }
            return true;
        }
    }
}
</script>

<style>

</style>